module.exports = __webpack_public_path__ + "static/media/storyIntro.5de33981.mp4";